import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { getToken } from 'Features/Auth/auth'
import { msalInstance } from './msal-instance'
const client = axios.create({
  baseURL: process.env.PLANNER_BASE_URL,
})

client.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      toast.dismiss()
      toast.error('You are not authorized to access this resource.')
      // const tokenRequest = {
      //   scopes: ['User.Read'], // Add the scopes your app needs
      //   account: msalInstance?.getActiveAccount() ?? undefined, // Use the logged-in account
      // }
      // msalInstance.acquireTokenRedirect(tokenRequest)
    }
    return Promise.reject(error)
  }
)

type ApiErrorBody = { error?: unknown; detail?: unknown; message?: unknown }

// The API's own words for a failed request: the `error` and `detail` of its
// response body (e.g. a 409 "Plan … is already RUNNING; wait …"), else its
// `message`, else `fallback`.
export const getApiErrorMessage = (error: unknown, fallback: string) => {
  const body = (error as AxiosError<ApiErrorBody>)?.response?.data
  const isText = (part: unknown): part is string =>
    typeof part === 'string' && part.trim().length > 0
  const parts = [body?.error, body?.detail].filter(isText)
  if (parts.length > 0) {
    return parts.join(' ')
  }
  return isText(body?.message) ? body.message : fallback
}

export const request = async (
  options: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const token = await getToken()
  client.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    client.defaults.headers.common.Tenant = tenantId
  }
  return client(options)
}
